import RN from '../images/RN.jpg'
import PT from '../images/PT.png'
import OT from '../images/OT.jpg'
import ST from '../images/ST.jpg'
import MSW from '../images/MSW.png'
import HHA from '../images/HHA.png'

const data =  [
    {
        id: 1,
        title: 'RN',
        subtitle: 'Nursing',
        description: [
            'Medication management',
            'Wound care and dressing changes',
            'Post-surgical care',
            'Chronic disease management',
            'Intravenous(IV) therapy'
        ],
        bgImg: RN,
    },
    {
        id: 2,
        title: 'PT',
        subtitle: 'Physical Therapy',
        description: [
            'Strengthening and mobility exercises',
            'Balance and fall prevention training',
            'Post-stroke rehabilitation',
            'Pain management',
        ],
        bgImg: PT,
    },
    {
        id: 3,
        title: 'OT',
        subtitle: 'Occupational Therapy',
        description: [
            'Adaptive techniques for independent living',
            'Hand therapy and fine motor skills improvement',
        ],
        bgImg: OT,
    },
    {
        id: 4,
        title: 'ST',
        subtitle: 'Speech Therapy',
        description: [
            'Speech and language rehabilitation',
            'Swallowing and feeding therapy',
            'Cognitive-communication therapy',
        ],
        bgImg: ST,
    },
    {
        id: 5,
        title: 'MSW',
        subtitle: 'Social Working',
        description: [
            'Emotional and psychological support for patients and families',
            'Assistance with community resources and financial aid programs',
            'Support with coping strategies and crisis intervention',
        ],
        bgImg: MSW,
    },
    {
        id: 6,
        title: 'HHA',
        subtitle: 'Home Health Aide',
        description: [
            'Assistance with daily activities (bathing, dressing, grooming)',
            'Light housekeeping and meal preparation',
            'Companionship and emotional support',
        ],
        bgImg: HHA,
    }
]

export default data